import { Aluminium1, Aluminium2, Aluminium3, Aluminium4, Aluminium5, BillingsImg, BillingsImgAr, Client1, Client2, Client3, Client4, Client5, Client6, Client7, Client8, Client9, ClientsImg, ClientsImgAr, Finishing1, Finishing2, Finishing3, Finishing4, Finishing5, Finishing6, Finishing7, Finishing8, FixIcon1, FixIcon2, FixIcon3, FixIcon4, Interior1, Interior2, Interior3, PageImg1, PageImg1Ar, PageImg2, PageImg2Ar, PageImg3, PageImg3Ar, PageImg4, PageImg4Ar, PageImg5, PageImg5Ar, PageImg6, PageImg6Ar, Portfolio1, Portfolio2, ProductImg, ProductImgAr, QuotationsImg, QuotationsImgAr, SalesInvoiceImg, SalesInvoiceImgAr, ServiceImg1, ServiceImg2, ServiceImg3, ServiceImg4, ServiceImg5, ServiceImg6, ServiceImg7, ServiceImg8, ServicesImg, SettingsImg, SettingsImgAr, SmartHome1, SmartHome2, SmartHome3, SmartHome4, SmartHome5, SwimmingPool1, SwimmingPool10, SwimmingPool11, SwimmingPool12, SwimmingPool13, SwimmingPool14, SwimmingPool15, SwimmingPool2, SwimmingPool3, SwimmingPool4, SwimmingPool5, SwimmingPool6, SwimmingPool7, SwimmingPool8, SwimmingPool9, ToolIcon1, ToolIcon2, ToolIcon3, ToolIcon4, ToolIcon5, ToolIcon6, ToolIcon7, UsersImg, UsersImgAr } from "../../ui/AllImages"
import { LazyImage } from "../../ui/Elements"
import i18n from '../../Languages/INEXT'

export const BenefitsList1 = [
	{
		icon: <FixIcon1 />,
		title: 'BenefitSaveTime',
		txt: 'DashboardView',
	},
    {
		icon: <FixIcon2 />,
		title: 'BenefitGetPaidFaster',
		txt: 'InvoiceView',
	},
    {
		icon: <FixIcon3 />,
		title: 'BenefitStayOrganized',
		txt: 'AccuracyView',
	},
    {
		icon: <FixIcon4 />,
		title: 'BenefitCustomize',
		txt: 'CustomizationView',
	},

]


export const serviceMaintaneData = [
    {
        
        heading: 'Products',
        icon: <ToolIcon1 />,
        img: <img src={PageImg1} alt="Services-Image" />,
        imgAr: <img src={PageImg1Ar} alt="Services-Image" />,
        list: [
            'ProductsDesc1',
            'ProductsDesc2',
            'ProductsDesc3',
            'ProductsDesc4',
            'ProductsDesc5',
            'ProductsDesc6',
        ]
    },
    {
        heading: 'Clients',
        icon: <ToolIcon2 />,
        img: <img src={PageImg2} alt="Services-Image" />,
        imgAr: <img src={PageImg2Ar} alt="Services-Image" />,
        list: [
            'ProductsDesc1',
            'ProductsDesc2',
            'ProductsDesc3',
            'ProductsDesc4',
            'ProductsDesc5',
            'ProductsDesc6',
        ]
    },
    {
        heading: 'Quotations',
        icon: <ToolIcon3 />,
        img: <img src={PageImg3} alt="Services-Image" />,
        imgAr: <img src={PageImg3Ar} alt="Services-Image" />,
        list: [
            'ProductsDesc1',
            'ProductsDesc2',
            'ProductsDesc3',
            'ProductsDesc4',
            'ProductsDesc5',
            'ProductsDesc6',
        ]
    },
    {
        heading: 'SalesInvoices',
        icon: <ToolIcon4 />,
        img: <img src={PageImg4} alt="Services-Image" />,
        imgAr: <img src={PageImg4Ar} alt="Services-Image" />,
        list: [
            'ProductsDesc1',
            'ProductsDesc2',
            'ProductsDesc3',
            'ProductsDesc4',
            'ProductsDesc5',
            'ProductsDesc6',
        ]
    },
    {
        heading: 'Users',
        icon: <ToolIcon5 />,
        img: <img src={PageImg5} alt="Services-Image" />,
        imgAr: <img src={PageImg5Ar} alt="Services-Image" />,
        list: [
            'ProductsDesc1',
            'ProductsDesc2',
            'ProductsDesc3',
            'ProductsDesc4',
            'ProductsDesc5',
            'ProductsDesc6',
        ]
    },
    /* {
        heading: 'Billing',
        icon: <ToolIcon6 />,
        img: <img src={BillingsImg} alt="Services-Image" />,
        imgAr: <img src={BillingsImgAr} alt="Services-Image" />,
        list: [
            'ProductsDesc1',
            'ProductsDesc2',
            'ProductsDesc3',
            'ProductsDesc4',
            'ProductsDesc5',
            'ProductsDesc6',
        ]
    }, */
    {
        heading: 'Settings',
        icon: <ToolIcon7 />,
        img: <img src={PageImg6} alt="Services-Image" />,
        imgAr: <img src={PageImg6Ar} alt="Services-Image" />,
        list: [
            'ProductsDesc1',
            'ProductsDesc2',
            'ProductsDesc3',
            'ProductsDesc4',
            'ProductsDesc5',
            'ProductsDesc6',
        ]
        
    },
    
]

export const pricingPlans = [
	{
		id: 1,
		plan_name: "basicPlan",
		desc: "basicPlanDesc",
		price: 0,
		btn_text: "get_started",
		color: "var(--themeColor2)",
		stroke: "var(--themeColor)",
		bg: "--white",
		border: "#eaedf3",
		isBorder: false,
		isCustom: false,
		isBasic: true,
		access_features: [
			"basicFeature1",
			"basicFeature2",
			"basicFeature3",
			"basicFeature4",
			"basicFeature5"
		]
	},
	{
		id: 2,
		plan_name: "professionalPlan",
		desc: "professionalPlanDesc",
		price: 300,
		btn_text: "get_started",
		color: "var(--white)",
		stroke: "var(--themeColor)",
		bg: "--themeColor",
		border: "var(--themeColor)",
		isBorder: true,
		isCustom: false,
		isBasic: false,
		access_features: [
			"proFeature1",
			"proFeature2",
			"proFeature3",
			"proFeature4",
			"proFeature5",
			"proFeature6",
		]
	},
	{
		id: 3,
		plan_name: "enterprisePlan",
		desc: "enterprisePlanDesc",
		price: 0,
		btn_text: "contact_sales_team",
		color: "var(--white)",
		stroke: "var(--themeColor2)",
		bg: "--white",
		border: "#eaedf3",
		isBorder: false,
		isCustom: true,
		isBasic: false,
		access_features: [
			"enterpriseFeature1",
			"enterpriseFeature2",
			"enterpriseFeature3",
			"enterpriseFeature4",
			"enterpriseFeature5",
			"enterpriseFeature6",
		]
	},
]

/* 

export const clientsItems = [
    {
        img: <img className='client-img' src={Client1} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client2} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client3} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client4} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client5} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client6} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client7} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client8} alt="client" />,
    },
	{
        img: <img className='client-img' src={Client9} alt="client" />,
    },
] */

export const FaqsList = [
    {
        question: 'question1',
        answer: "answer1",
    },
    {
        question: 'question2',
        answer: "answer1",
    },
    {
        question: 'question3',
        answer: "answer1",
    },
    {
        question: 'question4',
        answer: "answer1",
    },
    {
        question: 'question5',
        answer: "answer1",
    },

]